import * as React from 'react';

export const BookmarkIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='7'
    height='13'
    viewBox='0 0 7 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <path
      d='M0 12.1249V0.124878H7V12.1249L3.5 10.1249L0 12.1249Z'
      fill='currentColor'
    />
  </svg>
);
